import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/faq").then((r) => setFaqs(r.data.faqs || []));
  }, []);

  const grouped = faqs.reduce((acc, f) => {
    (acc[f.category || "Général"] = acc[f.category || "Général"] || []).push(f);
    return acc;
  }, {});

  return (
    <div>
      <section className="hero-bg py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="text-gold uppercase tracking-widest text-sm font-semibold">Questions fréquentes</div>
          <h1 className="font-heading text-4xl text-primary-blue mt-3">Foire aux questions</h1>
          <p className="mt-4 text-slate-700 text-lg">Retrouvez les réponses aux questions les plus courantes sur notre service.</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-14 space-y-12">
        {Object.entries(grouped).map(([cat, items]) => (
          <div key={cat}>
            <h2 className="font-heading text-2xl text-primary-blue mb-4">{cat}</h2>
            <Accordion type="single" collapsible className="bg-white rounded-2xl border border-slate-100 card-lux">
              {items.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="px-6" data-testid={`faq-${f.id}`}>
                  <AccordionTrigger className="text-left font-medium text-lg text-slate-800">{f.question}</AccordionTrigger>
                  <AccordionContent className="text-slate-700 text-base leading-relaxed">{f.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </section>
    </div>
  );
}
